export default "__VITE_ASSET__DeYyFqnr__"